// Shared motion helpers for the v6 "Ceremonial" interaction layer.
// Keep these tiny and dependency-free; all visual choreography lives in
// src/index.css (the v6 block). These cover the few moments that genuinely
// need JS (one-shot canvas reward bursts, the reduced-motion gate, the
// View-Transitions route-swap guard).

// True when the user (or the OS) wants calm/no motion. Honors both the OS
// setting AND the in-app "Calm reading" toggle (a `calm-reading` class on
// <html>), so a reader can damp motion without changing their system.
export function prefersReduced() {
  try {
    const root = document.documentElement;
    if (root.classList.contains('reduce-motion') || root.classList.contains('calm-reading')) return true;
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  } catch {
    return false;
  }
}

// One-shot gold-dust puff on a <canvas> — particles rise from the lower-middle
// and fade over ~800ms, then the canvas clears itself. The brand reward beat
// for big moments (fate draw, gacha pull). No-op under reduced motion.
export function goldPuff(canvas, opts = {}) {
  if (!canvas || prefersReduced()) return;
  const ctx = canvas.getContext && canvas.getContext('2d');
  if (!ctx) return;
  const W = canvas.width, H = canvas.height;
  const N = opts.count || 30;
  const t0 = performance.now();
  const gold = (getComputedStyle(document.documentElement)
    .getPropertyValue('--ds-gold').trim()) || '#c4a882';
  const p = Array.from({ length: N }, () => ({
    x: W * (0.3 + Math.random() * 0.4),
    y: H * (opts.fromY || 0.62),
    vx: (Math.random() - 0.5) * 0.9,
    vy: -(0.9 + Math.random() * 1.6),
    r: 1 + Math.random() * 2.1,
  }));
  function frame(now) {
    const e = now - t0;
    ctx.clearRect(0, 0, W, H);
    ctx.fillStyle = gold;
    for (const d of p) {
      d.x += d.vx; d.y += d.vy; d.vy += 0.018;
      ctx.globalAlpha = Math.max(0, 1 - e / 800);
      ctx.beginPath();
      ctx.arc(d.x, d.y, d.r, 0, 7);
      ctx.fill();
    }
    ctx.globalAlpha = 1;
    if (e < 800) requestAnimationFrame(frame);
    else ctx.clearRect(0, 0, W, H);
  }
  requestAnimationFrame(frame);
}

